import { assign } from 'lodash';

var i18n = require('i18next').default;
var i18nextSprintfPostprocessor = require('i18next-sprintf-postprocessor');
var XHR = require('i18next-xhr-backend');

var Config = require('./config');


var i18nDefaultOptions = {
  ns: ['main'],
  lngWhiteList: ['en-GB'],
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  nonExplicitWhitelist: true,
  load: 'currentOnly',
  interpolationPrefix: '%{',
  interpolationSuffix: '}',
  keySeparator: '>>',
  nsSeparator: '<<',
  debug: false,

  backend: {
    loadPath: '/locale/{{ns}}/{{lng}}.json'
  },

  interpolation: {
    escapeValue: false
  }
};

const loadedI18n = new Promise((resolve) => {
  i18n.on('loaded', () => resolve(i18n));
});

Config.configPromise.then((config) => {
  var options = assign({}, i18nDefaultOptions);

  options.lngWhiteList = config.availableLanguages || options.lngWhiteList;
  options.lng = config.defaultLanguage || options.lng;
  options.fallbackLng = config.defaultLanguage || options.lng;

  i18n.use(XHR)
    .use(i18nextSprintfPostprocessor)
    .init(options);

}).catch(() => {
  i18n.use(XHR)
    .use(i18nextSprintfPostprocessor)
    .init(i18nDefaultOptions);
});

i18n._n = function (n1, n2, options, t) {
  if(options.count === 1) {
    return t(n1, options);
  }

  return t(n2, options);
};


const i18nModule = module.exports = i18n;
i18nModule.loadedI18n = loadedI18n;
